import React, {Component} from 'react';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import MultipleProduct from './MultipleProduct'
import SingleProduct from './SingleProduct'
import PrepaidProduct from './PrepaidProduct'

class LevelExpansion extends Component {

    render(){
        const { level , defaultExpanded} = this.props
        var level_products = []



        const products = ()=> { 
            var components = [] 
            const {selectFunction} = this.props
            //turn products into arrays - if > 1 show multi product
            if (level.ident !== "prepaid"){ 
                level.products.forEach( ( product, i )=>{
                    if (!level_products[product.name]){
                        level_products[product.name] = []
                    }
                    level_products[product.name].push(product) 
                })
                for (var key in level_products) {
                  if ( level_products.hasOwnProperty(key))
                    var value = level_products[key];
                    if (value.length > 1){
                        components.push( <MultipleProduct key={key} selectFunction={selectFunction} products={value} /> )
                    }else{
                        components.push( <SingleProduct key={key} selectFunction={selectFunction} product={value[0]} /> )
                    }
                }
            }else{
                level.products.forEach( ( product, i )=>{
                    components.push( <PrepaidProduct key={i} selectFunction={selectFunction} product={product} />)
                })
            }
            return components 
        }


        return (
            <ExpansionPanel className="expandPanel" defaultExpanded={defaultExpanded} >
            <ExpansionPanelSummary className="accordHeader" expandIcon={<ExpandMoreIcon className='whiteIcon' />}>
                <div className="expansionheader">{level.name} {level.club_amount_text}</div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className="expansionPanelDetails">
                <div className='productHolder'>
                    {products()}
                </div>
            </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }
}
export default LevelExpansion



// WEBPACK FOOTER //
// ./src/components/DGR/MembershipOptions/LevelExpansion.js